import { Translation } from '@ps/web-shared-components';
import { translatedLink } from '@ps/web-shared-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import {
  TXTWCL_Set_your_Xa_hrefXXN0XXdeposit__ELL,
  TXTWCL_Your_Xa_hrefXXN0XXdeposit_limi_ELL
} from './SetLimitContent.messages.json';

const SetLimitContent: React.FC<{ limitSet?: boolean }> = ({ limitSet }) => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const isEmbedded = useSelector(select.device.isEmbedded);

  const {
    modal: { enqueue }
  } = useDispatch<Dispatch>();

  const openRestrictDepositLimit = () => {
    isEmbedded
      ? window.starsweb?.app.execute('account/responsible/restrict-deposit-limit')
      : enqueue([{ path: depositLimitPath }]);
  };

  return (
    <span>
      <Translation
        {...(limitSet
          ? TXTWCL_Your_Xa_hrefXXN0XXdeposit_limi_ELL
          : TXTWCL_Set_your_Xa_hrefXXN0XXdeposit__ELL)}
        values={{ a: translatedLink({ onClick: () => openRestrictDepositLimit() }) }}
      />
    </span>
  );
};
export default SetLimitContent;
